import { render } from "./shoppingCentre.vue?vue&type=template&id=1b8d8c64&scoped=true"
import script from "./shoppingCentre.vue?vue&type=script&lang=js"
export * from "./shoppingCentre.vue?vue&type=script&lang=js"

import "./shoppingCentre.vue?vue&type=style&index=0&id=1b8d8c64&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b8d8c64"]])

export default __exports__